<div class="select-box" [ngClass]="{'no-label': noLabel !== false}">
    <select  [disabled]="disabled" [(ngModel)]="value" [attr.tabindex] ="tabindex"  [ngClass]="{'value-shown' : value != null }">
        <option [value]=null disabled hidden>{{placeholder}}</option>
        <option *ngFor="let value of values" value="{{value[config.key]}}">{{value[config.description]}}</option>
    </select>
    <label *ngIf="value != null && noLabel === false">{{placeholder}}</label>
    <ng-content></ng-content>
</div>